export const getLastFileByCreatedAt = <T extends { createdAt?: Date | string }>(
  files: T[],
): T | undefined => {
  if (files.length === 0) {
    return undefined;
  }

  return files
    .slice()
    .sort((left, right) => {
      const leftTime = left.createdAt ? new Date(left.createdAt).getTime() : 0;
      const rightTime = right.createdAt ? new Date(right.createdAt).getTime() : 0;
      return leftTime - rightTime;
    })
    .at(-1);
};
